<template>
    <tr v-if="editMode">
        <td>{{item.code}}</td>
        <td>
            <span class="text-truncate">
            {{item.title}}
            </span>
        </td>
        <td>
            <div style="max-width: 120px; position: absolute; display: block; margin-top: -35px;">
                <v-text-field
                        ref="price"
                        v-model="price"
                        :rules="priceRules"
                        required
                ></v-text-field>
            </div>
        </td>
        <td class="text-right" style="min-width: 140px">
            <v-btn text icon color="green lighten-2" small
                   @click="handleSaveClickButton"
                   :loading="progress(['updateClientService', item.id])"
                   :disabled="progress(['updateClientService', item.id])">
                <v-icon>fas fa-check</v-icon>
            </v-btn>
            <v-btn text icon color="red lighten-2" class="ml-0" small
                   @click="handleEditClickButton"
                   :disabled="progress(['updateClientService', item.id])">
                <v-icon>fas fa-times</v-icon>
            </v-btn>
        </td>
    </tr>
    <tr v-else>
        <td>
            {{item.code}}
        </td>
        <td>
            <span class="text-truncate">
                {{item.title}}
            </span>
        </td>
        <td>{{ item.price | currency }}</td>
        <td class="text-right" style="min-width: 140px">
            <v-btn text icon color="black lighten-2" class="mr-0" @click="handleEditClickButton">
                <v-icon small>fas fa-pencil-alt</v-icon>
            </v-btn>
            <v-btn text icon color="black lighten-2" class="ml-0" @click="handleDeleteButtonClick">
                <v-icon small>fas fa-trash-alt</v-icon>
            </v-btn>
            <confirm ref="confirm"></confirm>
        </td>
    </tr>
</template>

<script>
    import {mapActions, mapState, mapGetters} from 'vuex'
    import Confirm from '../../Common/Confirm'
    import {isNumeric} from '../../../helpers/numbers'

    export default {
        name: 'ClientServiceItem',
        props: {
            item: Object
        },
        components: {
            Confirm
        },
        data() {
            return {
                editMode: false,
                draft: {
                    price: this.item.price,
                },
                priceRules: [
                    (value) => {
                        let numeric = isNumeric(value)

                        if (!numeric) {
                            return 'Price must be numeric value'
                        }

                        if (parseFloat(value) < 0) {
                            return 'Price value must be positive or zero'
                        }

                        return true
                    }
                ]
            }
        },
        computed: {
            ...mapGetters('services', {
                progress: 'progress'
            }),
            price: {
                get: function () {
                    return this.item.price
                },
                set: function (newValue) {
                    this.draft.price = newValue
                }
            },
        },
        methods: {
            ...mapActions('services', {
                updateClientService: 'updateClientService',
                deleteClientService: 'deleteClientService'
            }),
            handleEditClickButton() {
                this.editMode = !this.editMode
            },
            async handleSaveClickButton() {
                const result = await this.updateClientService({
                    id: this.item.id,
                    price: this.draft.price,
                    clientId: this.item.clientId})

                if (result) {
                    this.reset()
                }
            },
            async handleDeleteButtonClick() {
                this.$refs.confirm.open('Delete client service', `Do you want to remove service from client with title: "${this.item.title}"? Important: the service to be removed should not be present in any cases`, {width: 600}).then(async (confirm) => {
                    if (!confirm) {
                        return
                    }

                    await this.deleteClientService(this.item)
                })
            },
            reset() {
                this.editMode = false
                this.draft.price = null
            }
        }
    }
</script>

<style scoped>

</style>